import { Reducer } from 'redux';
import { ActionType, CheckoutBankRedirectAction } from '../actions';
import { CheckoutBankredirectState } from './state';
import { getInitialState } from './utils';

export { CheckoutBankredirectState, getInitialState };

export const reducer: Reducer<CheckoutBankredirectState> = (
    state = getInitialState(),
    action,
) => {
    const typedAction = action as CheckoutBankRedirectAction;

    switch (typedAction.type) {
        case ActionType.setIsAppRebrandActive:
            return {
                ...state,
                isAppRebrandActive: typedAction.payload,
            };
        case ActionType.setLoading:
            return {
                ...state,
                isLoading: true,
            };
        case ActionType.setPayment:
            return {
                ...state,
                payment: typedAction.payload,
            };
        case ActionType.setRedirectInstructions:
            return {
                ...state,
                redirectInstructions: typedAction.payload,
            };
        default:
            return state;
    }
};
